<template>
  <div class="multiselect">
    <Tags
      :showError="showError"
      :isRequired="isRequired"
      v-if="isTag"
      :title="title"
      :value="submitValue"
      :justOne="justOne"
      classes="tags"
      @input="submitValue = $event"
      :limit="limit"
      noAddOnEnter
    />

    <BaseText v-else :title="title" :value="submitValue" classes="tags" @input="submitValue = $event" />

    <i class="fa-solid fa-caret-down icon-down" @click="showList = !showList"></i>

    <div v-if="!submitValue.length" @click="showList = !showList" class="open-list"></div>

    <div v-click-outside="closeList" v-if="showList" class="multiselect-list">
      <div class="mb-2">
        <BaseText :value="search" @input="search = $event" placeholder="جستجو..." />
      </div>

      <div class="list">
        <template v-if="inputSearch.length">
          <div v-for="(item, index) in inputSearch" :key="index" class="list-item" @click="addItem(item)">
            {{ item.value }}
          </div>

          <div v-if="!inputSearch.length">موردی یافت نشد!</div>
        </template>

        <slot v-else />
      </div>
    </div>
  </div>
</template>
<script>
import Tags from './formModules/Tags.vue'
import BaseText from './formModules/BaseText.vue'
export default {
  name: 'MultiSelectSearch',
  components: { Tags, BaseText },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
    },
    limit: {
      type: Number,
    },
    isTag: {
      type: Boolean,
    },
    justOne: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      required: false,
    },
    errorText: {
      type: String,
      default: 'وارد کردن این فیلد الزامی است',
    },
    isRequired: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showList: false,
      search: '',
      submitValue: '',
      selected: [],
      submitKey: '',
    }
  },
  mounted() {
    this.submitValue = this.value
    document.getElementById('tags-basic').readOnly = true
  },
  computed: {
    inputSearch() {
      if (!this.search) {
        return this.items
      } else return this.items.filter((item) => item.value.includes(this.search))
    },
  },
  watch: {
    value(c) {
      this.submitValue = c
    },
    'submitValue.length'() {
      this.selected = []
      if (typeof this.submitValue !== 'string') {
        this.submitValue.forEach((fullName) => {
          const item = this.items.find((i) => i.value.trim() == fullName.trim())
          if (item && item.key) {
            this.selected.push(item)
          }
        })
      } else this.selected = this.submitKey

      this.$emit('input', this.selected)
    },
  },
  methods: {
    closeList() {
      if (this.showList) {
        this.showList = false
      }
    },
    addItem(item) {
      if (this.isTag) {
        if (this.justOne && this.submitValue.length > 0) return
        this.submitValue.push(item.value)
      } else {
        this.submitValue = item.value
        this.submitKey = item.key
        this.showList = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.multiselect {
  position: relative;
  .icon-down {
    position: absolute;
    left: 10px;
    top: 7px;
    color: #999696;
    cursor: pointer;
  }
}

.multiselect-list {
  background: #fff;
  // border-radius: 16px;
  border: 1px solid #ccc;
  padding: 16px;
  margin-right: 100px;
  margin-top: 5px;
}

.list {
  height: 200px;
  overflow-y: auto;
}
.list-item {
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #cfcfcf44;
  }
}

.open-list {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  height: 35px;
  width: 90%;
  margin-right: 100px;
  z-index: 1;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

::v-deep .b-form-tags-button {
  display: none;
}
</style>
